// extracted by mini-css-extract-plugin
export default {"settings":"dashboard_settings__rc2XI","addMonitorButton":"dashboard_addMonitorButton__zuD8m"};